var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tkListLoading"},_vm._l((_vm.listNum),function(item){return _c('div',{key:item,staticClass:"tkListLoading_filter"},[_c('tk-skeleton-loader',{staticClass:"tkListLoading_filterTile"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }